import { DatenauswertungKennzahlenRenderer } from './DatenauswertungKennzahlenRenderer';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { parseValue } from '../../main/functions/strukturiert/Kennzahl';
import * as React from 'react';
import { WTable } from '../../core/table/WTable';

interface DatenauswertungKennzahlenBerechnungProps extends React.ClassAttributes<any> {
    data: any;
    standortTid: number;
}

interface DatenauswertungKennzahlenBerechnungState {
    kennzahlenByJahr: any[];
    kennzahlSelected: any;
    hideNull: boolean;
}

export class DatenauswertungKennzahlenBerechnung extends React.Component<DatenauswertungKennzahlenBerechnungProps, DatenauswertungKennzahlenBerechnungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            kennzahlenByJahr: null,
            kennzahlSelected: null,
            hideNull: true
        };
    }

    componentDidMount(): void {
        this.loadKennzahlenByJahr();
    }

    loadKennzahlenByJahr() {
        const { data } = this.props;
        const standortTid = this.props.standortTid || 'ALL' /* Gesamt */;
        const kennzahlenByJahr: any[] = [];
        const kennziffern_strukturiert = data[IDs.KENNZIFFERN_STRUKTURIERT];
        Object.keys(kennziffern_strukturiert).forEach((jahr: string) => {
            if (kennziffern_strukturiert[jahr][standortTid]) {
                const kennzahlenMap = kennziffern_strukturiert[jahr][standortTid];
                const kennzahlen = Object.keys(kennzahlenMap).map((kennzahl_key: string) => {
                    return {
                        kennzahl_key,
                        ...kennzahlenMap[kennzahl_key]
                    };
                });
                if (Array.isArray(kennzahlen) && kennzahlen.length > 0) {
                    kennzahlen.forEach((k: any) => {
                        const row = {
                            jahr,
                            ...k
                        };
                        kennzahlenByJahr.push(row);
                    });
                }
            }
        });
        this.setState({ kennzahlenByJahr });
    }

    loadRecursive() {
        // const allKennzahlen: any[] = [];
        // let loadStatus = 0;
        // const loadRecursive = (rows: any[], fields: any[], jahr?: number) => {
        //     loadStatus++;
        //     if (Array.isArray(rows)) {
        //         rows.forEach((r: any) => {
        //             allKennzahlen.push({
        //                 jahr: jahr || r.jahr,
        //                 ...r
        //             });
        //             fields.forEach((f: any) => {
        //                 const isFolder = Array.isArray(r[f.key]) && r[f.key].length > 0 && typeof f.getChildFields === 'function' ? true : false;
        //                 if (isFolder) {
        //                     loadRecursive(r[f.key], f.getChildFields(), jahr || r.jahr);
        //                 }
        //             });
        //         });
        //     }
        //     loadStatus--;
        //     if (loadStatus === 0) {
        //         this.setState({ allKennzahlen });
        //     }
        // };
    }

    render(): JSX.Element {
        if (!this.state.kennzahlenByJahr) {
            return null;
        }
        return (
            <div style={{ display: 'flex', flexDirection: 'row', fontSize: 12 }}>
                <div style={{ display: 'flex', flexDirection: 'column', width: 500 }}>
                    {this.renderFuncButtons()}
                    {this.renderKennzahlenTable()}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, marginLeft: 10, maxHeight: 600 }}>
                    {this.state.kennzahlSelected &&
                        <DatenauswertungKennzahlenRenderer
                            data={this.props.data}
                            kennzahlen={[this.state.kennzahlSelected]}
                        />
                    }
                </div>
            </div>
        );
    }

    renderFuncButtons(): JSX.Element {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', padding: 10 }}>
                <label>
                    <div style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', alignItems: 'center' }}>
                        <input
                            type='checkbox'
                            checked={this.state.hideNull}
                            onChange={(event: any) => {
                                const hideNull = event.target.checked;
                                this.setState({ hideNull });
                            }}
                        />
                        <span>{i18n('Nullwerte ausblenden', 'sys')}</span>
                    </div>
                </label>
            </div>
        );
    }

    removeNullItems(rows: any[]) {
        rows = JSON.parse(JSON.stringify(rows));
        const removeNull = (rows: any[]) => {
            if (Array.isArray(rows)) {
                rows.forEach((r: any) => {
                    if (Array.isArray(r.items)) {
                        r.items = r.items.filter((i: any) => i.value !== null || (Array.isArray(i.items) && i.items.length > 0));
                        if (r.items.length === 0) {
                            delete (r.items);
                        } else {
                            removeNull(r.items);
                        }
                    }
                });
            }
        };
        removeNull(rows);
        rows = rows.filter((r: any) => r.value !== null || (Array.isArray(r.items) && r.items.length > 0));
        return rows;
    }

    renderKennzahlenTable(): JSX.Element {
        const { hideNull } = this.state;
        const filterMethod = (filter: any, row: any) => {
            const filterVal = filter.value.toLowerCase();
            return (row[filter.id] && (row[filter.id] + '').toLowerCase().indexOf(filterVal) !== -1)
                || (row._subRows || []).find((r: any) => r[filter.id] && (r[filter.id] + '').toLowerCase().indexOf(filterVal) !== -1);
        };
        const aggregate = () => { };
        const columns: any[] = [
            { id: 'jahr', accessor: 'jahr', Header: i18n('Jahr', 'sys'), HeaderText: i18n('Jahr', 'sys'), type: 'number', filterMethod, aggregate },
            { id: 'bereich', accessor: 'bereich', Header: i18n('Bereich', 'sys'), HeaderText: i18n('Bereich', 'sys'), type: 'text', filterMethod, aggregate },
            { id: 'name', accessor: 'name', Header: i18n('Bezeichnung', 'sys'), HeaderText: i18n('Bezeichnung', 'sys'), type: 'text', filterMethod, aggregate }
            // { id: 'type', accessor: 'type', Header: i18n('Typ', 'sys'), HeaderText: i18n('Typ', 'sys'), type: 'text', filterMethod, aggregate }
            // { id: 'kennzahl_key', accessor: 'kennzahl_key', Header: i18n('Kennzahl', 'sys'), HeaderText: i18n('Kennzahl', 'sys'), type: 'text', filterMethod, aggregate }
        ];

        let data = this.state.kennzahlenByJahr;
        data = data.filter((r: any) => r.hidden !== true);
        if (hideNull) {
            data = this.removeNullItems(data);
        }
        // console.log(data);

        const jahrMap: any = {};
        data.forEach((k: any) => {
            k.bereich = parseValue(k.bereich) || k.bereich;
            jahrMap[k.jahr] = true;
        });
        const defaultExpanded = Object.keys(jahrMap).map(() => { return {}; });

        return (
            <div>
                <WTable
                    key={IDs.KENNZIFFERN_STRUKTURIERT}
                    entity={IDs.KENNZIFFERN_STRUKTURIERT}
                    module={IDs.MOD_ETOOL_ADMIN}
                    customClass={'Custom-ETA'}
                    customClassNames={['ReactTableFixedHeader500']}
                    data={data}
                    onAction={() => { }}
                    hideExport={true}
                    columns={columns}
                    columnWidths={[100, 100]}
                    pageSize={10}
                    showPagination={true}
                    pivotBy={['jahr']}
                    expanded={defaultExpanded}
                    defaultSorted={[
                        { id: 'jahr', asc: true },
                        { id: 'bereich', asc: true },
                        { id: 'name', asc: true }
                    ]}
                    customTdProps={(state: any, rowInfo: any, column: any) => {
                        if (rowInfo && rowInfo.original && this.state.kennzahlSelected) {
                            const selected = this.state.kennzahlSelected;
                            const row = rowInfo.original;
                            if (row.jahr === selected.jahr && row.kennzahl_key === selected.kennzahl_key) {
                                const style = { color: 'var(--color-button-text)', backgroundColor: 'var(--color-button-bg)'/*'#CFC'*/ };
                                return { style };
                            }
                        }
                        return {};
                    }}
                    customTrProps={(state: any, rowInfo: any, column: any) => {
                        if (rowInfo && rowInfo.original) {
                            const row = rowInfo.original;
                            const style = { cursor: 'pointer' };
                            const onClick = () => this.setState({ kennzahlSelected: row });
                            return { style, onClick };
                        }
                        return {};
                    }}
                />
            </div>
        );
    }
}
